export const isApple =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);

/** Renders a `Mod+key` shortcut the way the current platform spells it. */
export function modShortcut(key: string): string {
  return isApple ? `⌘${key}` : `Ctrl+${key}`;
}
